<template>
  <div class="text-center border p-5 p-md-7">
    <div class="p-5">
      <div class="p-4">
        <div class="back-button d-inline-block cursor-pointer"><font-awesome-icon class="fa-5x" :icon="['fas', 'check-circle']" /></div>
        <h3 class="fw-b pt-4">Registration Successfully</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped="scoped">
.back-button{
  color: var(--primary-color) !important;
  font-weight: bold;
  font-size: 16px;
}
.customer-checkbox {
  margin-top: 10px;
}
.login-input {
  height: 40px !important;
  padding: 10px 20px !important;
  box-shadow: none !important;
  margin-top: 10px;
}
.form-check {
  padding-left: 27px !important;
}
.login-field,
.login-field-last {
  margin-top: 30px !important;
}

.Minicart_button {
  width: 150px !important;
  height: 40px !important;
}
@media screen and (max-width: 768px) {
  .login-input {
    width: 100% !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .login-input {
    width: 250px !important;
  }
  .form-check-input input {
    width: 15px !important;
  }
}
</style>
